import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import { Sale } from "./models-service";

export const route_ns = `sale`;

class SaleService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getWithFilter(ids: String[], id_facility: number, periods: string[]): Promise<Sale[]> {
    const url = `${route_ns}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async save(pack: Sale[]) {
    return await request({
      url: route_ns,
      method: "post",
      data: {data: pack.map(({ tariff_instance_id, contractor_instance_id, ...rest }) => rest)},
    });
  }

  public async savePack(pack: Sale[]) {
    try {
      pack.forEach(row => {
        this.crud.save(row);
      });
    } catch (err) {
      console.log(err);
    }
  }

  public async delete(entitys: Sale[]) {
    const response: AxiosResponse["data"] = await request({
      url: route_ns,
      method: "delete",
      data: {data: entitys},
    });
  }
}

export default new SaleService();
